import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';
import type { AssignedCustomField } from 'services/custom-fields/schemas';
import { CustomFieldTextInput } from './CustomFieldTextInput';
import { getFieldTypeOption } from 'components/custom-fields/fieldTypeOptions';

type ReadonlyCustomFieldInputProps = {
  field: AssignedCustomField;
};

export function ReadonlyCustomFieldInput({ field }: ReadonlyCustomFieldInputProps) {
  const { t } = useTranslation();

  const fieldTypeOption = getFieldTypeOption(field.type);

  return (
    <Tooltip title={t('editor.variables.custom_field_template_tooltip')} placement="top">
      <span>
        <CustomFieldTextInput field={field} placeholder={field.placeholder || t(fieldTypeOption.defaultPlaceholderKey)} disabled />
      </span>
    </Tooltip>
  );
}
